import React from 'react';
import { Card, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { FaFileExcel } from 'react-icons/fa';
import GridTipoLogradouro from './GridTipoLogradouro';

// W-0743 — Exportar Excel: seletor de layout (IPTU/Completo) + grid de tipo logradouro (ADR-005).
// Fonte: cmbLayout (DFM:571-585) + chkExcel habilita layout/grid (pas:1620-1623).
const ExportarExcel = ({
  layout,
  onChangeLayout,
  tiposLogradouroCustom,
  onChangeCustom,
  onExportar,
  exportando,
  disabled,
}) => {
  return (
    <Card className="shadow-sm mb-3">
      <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff', fontWeight: 'bold' }}>
        Exportar Excel
      </Card.Header>
      <Card.Body className="py-2">
        <Row className="mb-2 align-items-end">
          <Col md={4}>
            <Form.Label className="font-weight-bold mb-1">Layout</Form.Label>
            <Form.Control
              as="select"
              size="sm"
              value={layout}
              onChange={(e) => onChangeLayout(e.target.value)}
            >
              <option value="IPTU">IPTU</option>
              <option value="COMPLETO">Completo</option>
            </Form.Control>
          </Col>
          <Col md={8} className="text-md-right mt-2 mt-md-0">
            <Button
              variant="success"
              onClick={onExportar}
              disabled={exportando || disabled}
            >
              {exportando ? (
                <Spinner animation="border" size="sm" className="mr-1" />
              ) : (
                <FaFileExcel className="mr-1" />
              )}
              Exportar Excel
            </Button>
          </Col>
        </Row>

        <GridTipoLogradouro custom={tiposLogradouroCustom} onChange={onChangeCustom} />
      </Card.Body>
    </Card>
  );
};

export default ExportarExcel;
